import {
  Component,
  Input,
  OnInit,
  OnDestroy,
  Output,
  EventEmitter,
  ViewChild,
} from '@angular/core';
import {Subject, takeUntil, filter, BehaviorSubject, switchMap } from 'rxjs';
import { ProjectService } from '../../../core/project.service';
import { ResourcesOfEntity } from '../../models/projects.model';
import { DxTagBoxComponent } from 'devextreme-angular';

@Component({
  selector: 'app-lots-tag-box',
  templateUrl: './lots-tag-box.component.html',
  styleUrls: ['./lots-tag-box.component.scss'],
})
export class LotsTagBoxComponent implements OnInit, OnDestroy {
  private _entityID: number = 0;
  @Input()
  set entityID(value: number) {
    this._entityID = value;
    this.lotsTagBox?.instance.clear();
    this.lotsLoaded$.next(value);
  }
  get entityID(): number {
    return this._entityID;
  }

  @Output() public onLotsSelected: EventEmitter<number[]> = new EventEmitter<
    number[]
  >();

  @ViewChild(DxTagBoxComponent, { static: false }) lotsTagBox:
    | DxTagBoxComponent
    | undefined;

  public dataSource: ResourcesOfEntity[] = [] as ResourcesOfEntity[];

  public tagBoxEnabled = true;

  public itemsSelected: number[] = [];

  private destroy$: Subject<void> = new Subject<void>();
  private lotsLoaded$: BehaviorSubject<number> = new BehaviorSubject<number>(0);

  constructor(private projectService: ProjectService) {}

  ngOnInit(): void {

    this.lotsLoaded$.pipe(
        filter(() => this.entityID > 0),
        takeUntil(this.destroy$),
        switchMap((value) => this.projectService.getLotsListOfEntity(value))
      )
      .subscribe((data: ResourcesOfEntity[] | boolean) => {
        if (Array.isArray(data)) {
          this.dataSource = data;
          this.tagBoxEnabled = false;
        } else {
          this.tagBoxEnabled = true;
        }
      });
  }

  ngOnDestroy(): void {
    this.itemsSelected = [];
    this.tagBoxEnabled = true;
    this.dataSource = [] as ResourcesOfEntity[];
    this.destroy$.next();
    this.destroy$.complete();
  }

  public onLotsChanged(e: any): void {
    this.itemsSelected = e.value;
    this.onLotsSelected.emit(this.itemsSelected);
  }

  public onHiddenBox(e: any): void {
    this.onLotsSelected.emit(this.itemsSelected);
  }
}
